import React, { useState } from 'react';
import { CardBody, Card } from 'reactstrap';
import Heading from 'components/Heading';
import DownloadCSV from 'components/DownloadCSV';
import DateRangeFilter from 'pages/Notifications/components/AllNotification/DateRangePicker';
import { EXPORTS_BIDS } from './BiddingOrderGraphQL';
import BiddingOrderOffers from './components/BiddingOrderOffers';
// import { OFFER_AND_DEMAND } from 'helper/constants';
// import CustomTabs from 'components/CustomTabs';
// import BiddingOrderDemands from './components/BiddingOrderDemands';

const getExportDateFilters = (dateRange) => {
  if (!dateRange?.startDate) return [];

  const startDate = new Date(dateRange.startDate);
  startDate.setHours(0, 0, 0, 0);

  const dateFilters = [
    {
      key: 'createdAt',
      value: String(startDate.valueOf()),
      type: 'DATE',
      op: 'GTE',
    },
  ];

  if (dateRange?.endDate) {
    const endDate = new Date(dateRange.endDate);
    endDate.setDate(endDate.getDate() + 1);
    endDate.setHours(0, 0, 0, 0);
    dateFilters.push({
      key: 'createdAt',
      value: String(endDate.valueOf()),
      type: 'DATE',
      op: 'LT',
    });
  }

  return dateFilters;
};

const BiddingOrders = () => {
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });
  // const location = useLocation();
  // const [activeTab, setActiveTab] = useState(
  //   location?.state?.value || OFFER_AND_DEMAND.OFFERS,
  // );
  // const toggle = (tab) => {
  //   if (activeTab !== tab) setActiveTab(tab);
  // };

  return (
    <div className="bidding-orders-page">
      <div className="pb-1 mb-3 top-head">
        <Heading title="Biddings" />
      </div>
      <Card className="border-0 card-box page-card-box">
        <CardBody>
          <div className="bidding-filter-row mb-3">
            <div className="vendor-date-filter bidding-date-filter">
              <DateRangeFilter
                dateRange={dateRange}
                onFilter={setDateRange}
              />
            </div>
            <DownloadCSV
              lazyQuery={EXPORTS_BIDS}
              filters={{
                filter: getExportDateFilters(dateRange),
                sortCol: 'createdAt',
                sortDirection: 'DESC',
              }}
              apiKey="exportBids"
              fileName="Bids"
              classWrapper="bids-download-btn"
              positionTop="0"
              positionRight="0"
            />
          </div>
          <BiddingOrderOffers dateRange={dateRange} />
          {/* <CustomTabs
            tabs={[OFFER_AND_DEMAND.OFFERS, OFFER_AND_DEMAND.DEMANDS]}
            selectedTab={activeTab}
            onTabChange={toggle}
          />
          <TabContent activeTab={activeTab}>
            {activeTab === OFFER_AND_DEMAND.OFFERS && (
              <TabPane tabId={OFFER_AND_DEMAND.OFFERS}>
                <BiddingOrderOffers />
              </TabPane>
            )}
            {activeTab === OFFER_AND_DEMAND.DEMANDS && (
              <TabPane tabId={OFFER_AND_DEMAND.DEMANDS}>
                <BiddingOrderDemands />
              </TabPane>
            )}
          </TabContent> */}
        </CardBody>
      </Card>
      {/* <Card className="border-0 card-box page-card-box">
        <CardBody>
          <CustomTabs
            tabs={[
              BIDS_TABS.ACTIVE_BIDS,
              BIDS_TABS.EXPIRED_BIDS,
              BIDS_TABS.ACCEPTED_BIDS,
              BIDS_TABS.REJECTED_BIDS,
              BIDS_TABS.WITHDRAWN_BIDS,
            ]}
            selectedTab={activeTab}
            onTabChange={toggle}
          />
          <TabContent activeTab={activeTab}>
            <TabPane tabId={BIDS_TABS.ACTIVE_BIDS}>
              {activeTab === BIDS_TABS.ACTIVE_BIDS && (
                <ErrorBoundary>
                  <CommonBidDetails status={BID_STATUS.IN_PROGRESS} />
                </ErrorBoundary>
              )}
            </TabPane>
            <TabPane tabId={BIDS_TABS.EXPIRED_BIDS}>
              {activeTab === BIDS_TABS.EXPIRED_BIDS && (
                <ErrorBoundary>
                  <CommonBidDetails status={BID_STATUS.EXPIRED} />
                </ErrorBoundary>
              )}
            </TabPane>
            <TabPane tabId={BIDS_TABS.ACCEPTED_BIDS}>
              {activeTab === BIDS_TABS.ACCEPTED_BIDS && (
                <ErrorBoundary>
                  <CommonBidDetails status={BID_STATUS.ACCEPTED} />
                </ErrorBoundary>
              )}
            </TabPane>
            <TabPane tabId={BIDS_TABS.REJECTED_BIDS}>
              {activeTab === BIDS_TABS.REJECTED_BIDS && (
                <ErrorBoundary>
                  <CommonBidDetails status={BID_STATUS.REJECTED} />
                </ErrorBoundary>
              )}
            </TabPane>
            <TabPane tabId={BIDS_TABS.WITHDRAWN_BIDS}>
              {activeTab === BIDS_TABS.WITHDRAWN_BIDS && (
                <ErrorBoundary>
                  <CommonBidDetails status={BID_STATUS.WITHDRAWN} />
                </ErrorBoundary>
              )}
            </TabPane>
          </TabContent>
        </CardBody>
      </Card> */}
    </div>
  );
};

export default BiddingOrders;
